"use strict";

var _regeneratorRuntime = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(numbers);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = number;
exports.numbers = numbers;

function number(x) {
  return x === null ? NaN : +x;
}

function numbers(values, valueof) {
  var _iterator, _step, value, index, _iterator2, _step2;

  return _regeneratorRuntime.wrap(function numbers$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!(valueof === undefined)) {
          _context.next = 21;
          break;
        }

        _iterator = _createForOfIteratorHelper(values);
        _context.prev = 2;

        _iterator.s();

      case 4:
        if ((_step = _iterator.n()).done) {
          _context.next = 11;
          break;
        }

        value = _step.value;

        if (!(value != null && (value = +value) >= value)) {
          _context.next = 9;
          break;
        }

        _context.next = 9;
        return value;

      case 9:
        _context.next = 4;
        break;

      case 11:
        _context.next = 16;
        break;

      case 13:
        _context.prev = 13;
        _context.t0 = _context["catch"](2);

        _iterator.e(_context.t0);

      case 16:
        _context.prev = 16;

        _iterator.f();

        return _context.finish(16);

      case 19:
        _context.next = 40;
        break;

      case 21:
        index = -1;
        _iterator2 = _createForOfIteratorHelper(values);
        _context.prev = 23;

        _iterator2.s();

      case 25:
        if ((_step2 = _iterator2.n()).done) {
          _context.next = 32;
          break;
        }

        value = _step2.value;

        if (!((value = valueof(value, ++index, values)) != null && (value = +value) >= value)) {
          _context.next = 30;
          break;
        }

        _context.next = 30;
        return value;

      case 30:
        _context.next = 25;
        break;

      case 32:
        _context.next = 37;
        break;

      case 34:
        _context.prev = 34;
        _context.t1 = _context["catch"](23);

        _iterator2.e(_context.t1);

      case 37:
        _context.prev = 37;

        _iterator2.f();

        return _context.finish(37);

      case 40:
      case "end":
        return _context.stop();
    }
  }, _marked, null, [[2, 13, 16, 19], [23, 34, 37, 40]]);
}